<div class="properties">
	<bb-scrollable-pane class="scroll-bar" [lockScrollObs]="dropdownOpenObs" #scrollablePane>
		<ng-container *ngFor="let prop of componentsToRender; let i=index; trackBy: trackBy" [ngSwitch]="prop.ctype">
			<div
				*ngSwitchCase="'pillbox'"
				class="property"
				[style.margin-left]="(prop.index === '__adjunct__' && prop.key !== 'textFormat/textFormat/color') || prop.key === 'height' ? '0' : '6px'"
				[style.margin-right]="prop.key === 'width' ? '0' : ''"
			>
				<bb-pillbox 
					[config]="prop" 
					[ind]="'ie-property-bar#'+i"
					(onChangeProperty)="changeProperty($event)">
				</bb-pillbox>
				<i [title]="(prop.aspectRatioLocked ? 'UN' : '') + 'LOCK_ASPECT_RATIO' | translate" *ngIf="prop.showAspectRatioLock" class="fa fa-chain lock-aspect-ratio" [ngClass]="{'fa-chain': prop.aspectRatioLocked, 'fa-chain-broken': !prop.aspectRatioLocked, 'disabled': aspectRatio <= 0}" (click)="toggleAspectRatioLocked(i)"></i>
			</div>

			<div class="divider" *ngIf="prop.dividerLine"></div>

			<div class="property property-adjunct" *ngSwitchCase="'pillbox_color'">
				<bb-pillbox [config]="prop" [ind]="'ie-property-bar#'+i" (onChangeProperty)="changeProperty($event)"></bb-pillbox>
			</div>

			<div class="property" *ngSwitchCase="'pillbox_multi'">
				<bb-pillbox [config]="prop" [ind]="'ie-property-bar#'+i" (onChangeProperty)="changeProperty($event)"></bb-pillbox>
			</div>

			<div class="property property-adjunct" *ngSwitchCase="'pillbox_mediaclip'">
				<bb-pillbox [config]="prop" [ind]="'ie-property-bar#'+i" (onChangeProperty)="changeProperty($event)" (onDropdownOpen)="onDropdownOpened($event)"></bb-pillbox>
			</div>
	
			<div class="property" *ngSwitchCase="'toggle'">
				<mat-button-toggle class="icon-center"[ngSwitch]="prop.index" name="{{prop.key}}" value="{{prop.value}}" checked="{{prop.value === 'true'}}" #box (change)="changeProperty({key: prop.key, val: (box.checked ? 'true' : 'false')})">
					<i *ngSwitchCase="'__bold__'" class='fa fa-bold'></i>
					<i *ngSwitchCase="'__italic__'" class='fa fa-italic'></i>
					<i *ngSwitchCase="'__underline__'" class='fa fa-underline'></i>
				</mat-button-toggle>
			</div>

			<div class="property" *ngSwitchCase="'select'" [ngSwitch]="prop.index" >
				<mat-button-toggle-group *ngSwitchCase="'__align__'" #group="matButtonToggleGroup" name="{{prop.key}}" value="{{prop.value}}">
					<mat-button-toggle class="icon-center" value="left" (change)="changeProperty({key: prop.key, val: group.value})">
						<i class="fa fa-align-left"></i>
					</mat-button-toggle>
					<mat-button-toggle class="icon-center" value="center" (change)="changeProperty({key: prop.key, val: group.value})">
						<i class="fa fa-align-center"></i>
					</mat-button-toggle>
					<mat-button-toggle class="icon-center" value="right" (change)="changeProperty({key: prop.key, val: group.value})">
						<i class="fa fa-align-right"></i>
					</mat-button-toggle>
				</mat-button-toggle-group>
			</div>
		</ng-container>
	</bb-scrollable-pane>

</div>
